// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"3cc6a479","312":"aea330a0","410":"6a57b546","465":"da63a400","538":"8fe016bb","829":"49b03f7e","846":"d91cbf0d","953":"c5819a05"}[chunkId] + ".chunk.js";
};